<template>
	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/model/object/page"
			getKey="rows" :columns="columns">
			<!-- 	<template #top>
				<div style="display: flex;flex-wrap: nowrap;flex-direction: row;margin-right: 400px;">
					<template v-if="$attrs.series">
					<el-descriptions :colon="false">
						<el-descriptions-item :label="$t('shebeileixing')">
							{{$t(store.state.dictJson['EQUIPMENT_TYPES'][$attrs.series.typeId])}}</el-descriptions-item>
					</el-descriptions>
					<el-descriptions :colon="false">
						<el-descriptions-item :label="$t('shebeixiliemingcheng')">{{$attrs.series.name}}
						</el-descriptions-item>
					</el-descriptions>
					</template>
				</div>
			</template> -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<div v-if="$attrs.series">
						<el-form-item :label="$t('shebeileixing')" class="noborder">
							<el-input disabled
								:value="$t(store.state.dictJson['EQUIPMENT_TYPES'][$attrs.series.typeId])"></el-input>
						</el-form-item>
						<el-form-item :label="$t('shebeixiliemingcheng')" class="noborder">
							<el-input disabled v-model="$attrs.series.name">
							</el-input>
						</el-form-item>
					</div>
					<el-form-item v-if="$attrs.series" :label="$t('shebeixinghao')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item v-if="$attrs.series">
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({seriesId:yt.conditions.seriesId})">{{$t('chongzhi')}}</el-button>
					</el-form-item>
					<div v-if="!$attrs.series">
						<el-form-item :label="$t('shebeixinghao')">
							<el-input v-model="yt.conditions.code"></el-input>
						</el-form-item>
						<el-form-item :label="$t('shebeileixing')">
							<yi_dictionary_select :type="'EQUIPMENT_TYPES'" :ids.sync="yt.conditions.seriesTypeId">
							</yi_dictionary_select>
						</el-form-item>
						<el-form-item>
							<el-button @click="yt.get(1)" type="primary" plain="plain">
								{{$t('sousuo')}}
							</el-button>
							<el-button @click="yt.clear({seriesId:yt.conditions.seriesId})">{{$t('chongzhi')}}</el-button>
						</el-form-item>
					</div>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng xinghao',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/model/delete')">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng xinghao'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder" :label="$t('shebeileixing')">
						{{$t(store.state.dictJson['EQUIPMENT_TYPES'][$attrs.series.typeId])}}
					</el-form-item>
					<el-form-item class="noborder" :label="$t('shebeixiliemingcheng')">
						<el-input disabled v-model="$attrs.series.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shebeixinghao')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhizaoshang')">
						<el-input v-model="yt.editObj.manufacturer"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/equipment/model/create',beforeAdd)"
						type="primary">{{$t('baocun')}}
					</el-button>

				</span>
			</template>
			<!-- 更新列表 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeileixing')">
						{{$t(store.state.dictJson['EQUIPMENT_TYPES'][$attrs.series.typeId])}}
					</el-form-item>
					<el-form-item class="noborder" :label="$t('shebeixiliemingcheng')">
						<el-input disabled v-model="$attrs.series.name"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('shebeixinghao')" required>
						<el-input disabled v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhizaoshang')">
						<el-input v-model="yt.editObj.manufacturer"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/equipment/model/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'admin_equipment_series_series_model',
		data() {
			return {
				status: [{
						label: "是",
						value: true
					},
					{
						label: "否",
						value: false
					}
				],
				columns: [

					{
						label: 'shebeixinghao',
						prop: 'code',
						width: 130
					},
					// {
					// 	label: 'shebeileixing',
					// 	prop: 'seriesTypeId',
					// 	type: 'dictionary',
					// 	key: 'EQUIPMENT_TYPES'
					// },
					// {
					// 	label: 'shebeixiliemingcheng',
					// 	prop: 'seriesName'
					// },
					{
						label: 'zhizaoshang',
						prop: 'manufacturer',

					}, {
						label: 'caozuo',
						type: 'slot',
						width: 130,
						fixed: 'right'
					}
				]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy: 'createTime desc',
				}
				this.yt.SELECT_URL = "/web/equipment/model/listByIds"
				this.yt.SELECT_RESULT_KEY = "data"
				this.yt.SELECT_ID = "id"
				this.yt.SELECT_TITLE = "code"
				this.yt.conditions.seriesId = this.$attrs.series && this.$attrs.series.id
				this.yt.get(1)
			}, 300)
		},
		methods: {
			beforeAdd(params, url) {
				params.seriesId = this.$attrs.series.id;
				// params.typeId = this.$attrs.series.id
				return params
			},
		}
	};
</script>
<style>
</style>
